import { getPageMeta } from '@/routes-utils/get-page-meta.ts';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap.ts';
import { LoginComponent } from './login-component.tsx';

export const handle: SeoHandle = {
  sitemap: true,
};

export const meta = () =>
  getPageMeta({
    url: 'https://synoptic.com/auth/login',
  });

export default function AuthLogin() {
  return <LoginComponent />;
}
